import styled from '@emotion/styled'
import { pxToRem } from 'utils/styled'
import { Text } from 'components/Typography'
import { css } from '@emotion/react'

export const SWizardCardItem = styled.div<{
  active?: boolean
  disabled?: boolean
  isLoading?: boolean
}>`
  box-shadow: var(--card-shadow);
  padding: 1rem;
  border-radius: 4px;
  background: var(--c-white);
  cursor: pointer;
  position: relative;

  display: flex;
  align-items: stretch;
  justify-content: stretch;

  transition: box-shadow 0.2s;

  &:hover {
    box-shadow: var(--card-shadow-hover);
  }

  &:active {
    box-shadow: var(--card-shadow-active);
  }

  &:after {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    content: '';
    pointer-events: none;
    border-radius: 4px;
    transition: all 0.2s;
  }

  & > * {
    width: 100%;
  }

  ${({ isLoading, disabled }) => {
    if (isLoading || disabled) {
      return css`
        box-shadow: none !important;
      `
    }
    return null
  }}

  ${({ active }) => {
    if (active) {
      return css`
        &:after {
          pointer-events: none;
          border: 2px solid var(--c-blue500);
          z-index: 1;
        }
      `
    }
    return null
  }}
`

export const SWizardCardItemBig = styled.div<{
  active?: boolean
  disabled?: boolean
  isLoading?: boolean
}>`
  min-height: 12rem;
  box-shadow: var(--card-shadow);
  padding: 1rem;
  border-radius: 4px;
  background: var(--c-white);
  cursor: pointer;
  position: relative;

  display: flex;
  align-items: stretch;
  justify-content: stretch;

  transition: box-shadow 0.2s;

  &:hover {
    box-shadow: var(--card-shadow-hover);
  }

  &:active {
    box-shadow: var(--card-shadow-active);
  }

  & > * {
    width: 100%;
  }

  ${({ isLoading, disabled }) => {
    if (isLoading || disabled) {
      return css`
        cursor: auto;
        box-shadow: var(--card-shadow-light) !important;
      `
    }
    return null
  }}
`

export const SWizardCardHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  min-height: 30px;

  & > svg {
    width: 28px;
    height: 28px;
  }
`

export const SWizardCardDuration = styled(Text.withComponent('span'))`
  font-size: ${pxToRem(11)}rem;
  font-weight: bold;
  display: flex;
  padding: 2px 10px;
  border: 1px solid var(--c-blue100);
  border-radius: 2px;
  flex-shrink: 0;
`

export const SWizardCardTitle = styled(Text)`
  color: var(--c-gray100);
  font-weight: bold;
  margin-top: 0.25em;
  height: ${pxToRem(56)}rem;
`

export const SWizardCardDescription = styled(Text)`
  font-size: ${pxToRem(14)}rem;
`

export const SLoadingContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  display: flex;
  align-items: center;
  justify-content: center;

  pointer-events: all;
  background: rgba(247, 251, 253, 0.8);
  z-index: 1;
  border: 2px solid var(--c-blue100);

  cursor: default;
`
